import { Route, Routes } from 'react-router-dom'

import Overview from './screens/Overview'
import PortalSyncs from '../Overviews/screens/PortalSyncs'

const DashboardRoutes = () => (
  <Routes>
    <Route path="/" element={<Overview />} />
    <Route path="/portalSyncs" element={<PortalSyncs />} />
  </Routes>
)

export default DashboardRoutes
